<template>
  <el-dialog
    :title="$t('text.pod_and_diaper')"
    width="1300px"
    :visible="dialogVisible"
    :append-to-body="true"
    @close="handleClose"
    class="show-more-section"
  >
    <div class="pod-diaper popover-content">
      <el-row :gutter="20">
        <el-col :xs="24" :md="16">
          <div class="mb-10">{{ $t('text.video') }}</div>
          <video-player
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
          >
          </video-player>
        </el-col>
        <el-col :xs="24" :md="8">
          <div v-html="$t('text.pod_and_diaper_content')"></div>
        </el-col>
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
export default {
  data() {
    return {
      dialogVisible: false,
      playerOptions: {
        muted: true,
        autoplay: true,
        loop: true,
        width: 800,
        language: this.$store.state.locale.currentLocale,
        sources: [
          {
            type: 'video/mp4',
            src: require('@/assets/video/smartz-clippingpod-en.mp4')
          }
        ]
      }
    }
  },
  components: {
    videoPlayer
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    handleClose() {
      // After close show more popup, then start the autoplay of the carousel
      this.$emit('changeAutoPlay', true)
      this.dialogVisible = false
    }
  }
}
</script>
